import { EscopoMacroNovoView } from "./view-escopo-macro-novo";

export function EscopoMacroNovo() {
  return <EscopoMacroNovoView />;
}

export type * from "./types-escopo-macro-novo";
